import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Updated import
import "./MyProfile.css";
import { jwtDecode } from "jwt-decode";

function MyProfile() {
  const navigate = useNavigate(); // Updated hook
  const storedJwt = localStorage.getItem("token");
  const [jwt, setJwt] = useState(storedJwt || null);
  const showToken = useState(false);

  function logOut() {
    localStorage.removeItem("token");
    setJwt(null);
    navigate("/SignIn");
  }

  function formatDateTime(epochTimeStamp) {
    var d = new Date(epochTimeStamp * 1000);
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var year = d.getFullYear();
    var month = months[d.getMonth()];
    var date = d.getDate();
    var hour = d.getHours();
    var min = (d.getMinutes() < 10 ? "0" : "") + d.getMinutes();
    var sec = (d.getSeconds() < 10 ? "0" : "") + d.getSeconds();
    var time =
      date + ". " + month + " " + year + " " + hour + ":" + min + ":" + sec;
    return time;
  }

  function displayToken(key) {
    if (jwt !== "null") {
      try {
        console.info("token received: " + jwt.substring(0, 10) + "******");
        var decodedJwt = jwtDecode(jwt);
        if (key === "exp") {
          let ms = decodedJwt["exp"];
          var formattedDateTime = formatDateTime(ms);
          return formattedDateTime;
        }

        if (key === "token") {
          return jwt.substring(0, 10) + "******";
        }
        return decodedJwt[key];
      } catch (e) {
        localStorage.removeItem("token");
        setJwt(null);
        console.error(e);
        setJwt("null");
      }
    } else {
      return "Token Expired";
    }
  }

  return (
    <>
      <div className="myprofile-container">
        <div className="card">
          <img
            alt=""
            src="user_profile.png"
            style={{ width: "100px", height: "100px", objectFit: "cover" }}
          />
          <header>
            <h1 style={{ textTransform: "capitalize" }}>
              {jwt === null ? "" : displayToken("cognito:username")}
            </h1>
          </header>
          <br />
          <h5>Job title</h5>
          <h5>{jwt === "null" ? "NA" : "Development Engineer"}</h5>
          <br />
          <h5>email</h5>
          <h5>{jwt === "null" ? "NA" : displayToken("email")}</h5>
          <br />
          <h5>Company</h5>
          <h5>{jwt === "null" ? "NA" : "Scania CV AB"}</h5>
          <br />
          <h5>Token</h5>
          <h5>{jwt === "null" && !showToken ? "" : displayToken("token")}</h5>
          <br />
          <h5>Valid Until</h5>
          <h5>{jwt === "null" && !showToken ? "" : displayToken("exp")}</h5>
          <br />
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => logOut()}
          >
            {jwt === "null" ? "LogIn" : "LogOut"}
          </button>
        </div>
      </div>
    </>
  );
}

export default MyProfile;
